var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKinto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 690,
    height: 77,
    xmlSpace: "preserve",
    id: "logoKINTOChargeCanvas",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logoKINTOChargeCanvas-group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 109.4,17.4 L 122,17.4 C 126,17.4 128.5,19.3 131.4,23 L 152.2,56.5 152.4,56.5 152.4,17.4 158.6,17.4 C 161.9,17.4 164.4,19.8 164.4,23.2 L 164.4,75.7 159.7,75.7 C 154.1,75.7 151.5,74.5 148,69.9 L 127.4,36.7 127.2,36.7 127.2,75.7 121,75.7 C 117.9,75.7 115.2,73.4 115.2,69.9 L 115.2,23.2 C 115.2,20 112.7,17.4 109.4,17.4 Z M 109.4,17.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier2",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 177.2,17.4 L 224.9,17.4 C 228.4,17.4 230.7,20.2 230.7,23.2 L 230.7,29.1 213.2,29.1 213.2,75.7 206.2,75.7 C 203,75.7 200.4,73.4 200.4,69.9 L 200.4,29.1 188.7,29.1 C 185.4,29.1 182.9,26.6 182.9,23.2 183,20.1 180.5,17.4 177.2,17.4 Z M 177.2,17.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier3",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 75.8,69.9 L 75.8,31 82.8,31 C 86,31 88.6,33.4 88.6,36.8 L 88.6,75.7 81.6,75.7 C 78.5,75.7 75.8,73.2 75.8,69.9 Z M 75.8,69.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier4",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 5.8,23.2 L 5.8,69.9 C 5.8,73.2 8.3,75.7 11.6,75.7 L 18.6,75.7 18.6,54.2 18.6,54.2 34.7,70.6 C 39.5,75.2 42.4,75.7 46.4,75.7 L 55.7,75.7 26.3,46.6 55.7,17.5 39.7,17.5 18.6,38.9 18.6,38.9 18.6,23.2 C 18.6,20.3 16.3,17.4 12.8,17.4 L 0,17.4 C 3.2,17.4 5.8,20.3 5.8,23.2 Z M 5.8,23.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier5",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 271.6,16 C 254.7,16 241.1,29.7 241.1,46.5 241.1,63.4 254.8,77 271.6,77 288.5,77 302.1,63.3 302.1,46.5 302.1,29.7 288.4,16 271.6,16 Z M 271.6,65.4 C 261.2,65.4 252.8,57 252.8,46.6 252.8,36.2 261.2,27.8 271.6,27.8 282,27.8 290.4,36.2 290.4,46.6 290.4,56.9 282,65.4 271.6,65.4 Z M 271.6,65.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier6",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 82.7,11.6 C 81,10.3 78.3,10 76,11.6 72.8,13.8 72.4,17.8 74.2,21 75.9,24.1 79.2,25.2 82.9,24.8 87.1,24.4 90.5,22.1 92.5,19.4 94.3,17 96.2,11.1 92.4,5.6 89.5,1.4 85.8,-0 81.8,-0 77.4,-0 74.3,3.3 72.2,5.8 68.9,9.7 67.4,10.5 64.6,10.8 61.8,11 59.2,9.8 57.9,8.5 56.6,7.2 55.9,6.2 55.9,6.2 55.9,6.2 57.5,9.1 59.6,10.9 61.9,12.8 65.4,13.7 69.1,12.4 73.5,10.8 76,8 77.5,7.2 80.5,5.5 84.7,6.9 85.5,10 86.5,13.6 84.6,16 84.6,16 84.6,16 85.1,13.5 82.7,11.6 Z M 82.7,11.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logoKINTOChargeCanvas-group2",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "logoKINTOChargeCanvas-group3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier7",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 326.5,46.6 C 326.5,28.7 339.5,16.6 357.1,16.6 364.9,16.6 371.4,19 376.3,22.3 L 372.7,32.3 C 368.4,29.3 363.3,27 357.5,27 345.9,27 338.1,35 338.1,46.4 338.1,57.6 345.7,66 357.5,66 364.1,66 370,63.4 374.1,60.4 L 377.2,70.2 C 371.6,74.1 365.2,76.4 356.7,76.4 339,76.4 326.5,64.2 326.5,46.6 Z M 326.5,46.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier8",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 441,17.4 L 441,75.7 429.9,75.7 429.9,51.4 403.6,51.4 403.6,75.7 392.5,75.7 392.5,17.4 403.6,17.4 403.6,41.7 429.9,41.7 429.9,17.4 441,17.4 Z M 441,17.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier9",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 493.2,59.2 L 472.4,59.2 466.7,75.6 455.5,75.6 477.2,17.3 489.2,17.3 510.9,75.6 499.2,75.6 493.2,59.2 Z M 490,50.4 L 482.7,29.5 475.4,50.4 490,50.4 Z M 490,50.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier10",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 543.1,52.9 L 536,52.9 536,75.6 525,75.6 525,17.3 545.3,17.3 C 557.8,17.3 564.7,24.6 564.7,34.4 564.7,41.5 560.9,47.8 553.8,50.9 L 569.9,75.6 556.9,75.6 543.1,52.9 Z M 536.1,44.1 L 543.6,44.1 C 548.8,44.1 553.1,41.3 553.1,35.2 553.1,29.1 548.9,26.6 543.7,26.6 L 536.1,26.6 536.1,44.1 Z M 536.1,44.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier11",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 635.9,45.2 L 635.9,75.7 625.8,75.7 625.8,67.9 C 622.8,72.2 616.4,76.5 607.2,76.5 591.4,76.5 579.5,64.3 579.5,46.7 579.5,28.4 592.9,16.5 610,16.5 619,16.5 625.9,19.5 631.7,23.5 L 627.8,33.5 C 622.6,29.6 617,26.9 610,26.9 599.4,26.9 591,34 591,46.6 591,58.7 598.5,65.9 608.9,65.9 618.6,65.9 624.2,59.9 625.2,54.1 L 608.9,54.1 608.9,45.2 635.9,45.2 Z M 635.9,45.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoKINTOChargeCanvas-bezier12",
    stroke: "none",
    fill: "rgb(4, 112, 141)",
    d: "M 654.4,17.4 L 689.3,17.4 689.3,27.2 665.5,27.2 665.5,41.8 688.6,41.8 688.6,51.2 665.5,51.2 665.5,65.9 689.9,65.9 689.9,75.7 654.4,75.7 654.4,17.4 Z M 654.4,17.4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinto);
export default __webpack_public_path__ + "static/media/kinto.a17368d5b88a5a86a96fe5b722f4db96.svg";
export { ForwardRef as ReactComponent };